"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _leftChevron = _interopRequireDefault(require("../../assets/images/left-chevron.svg"));

var _backArrow = _interopRequireDefault(require("../../assets/images/back-arrow.svg"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-right: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  font-weight: 600;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  outline: none;\n\n  /* Focus styles on on keyboard focus */\n  &:hover,\n  &[data-focus-visible-added]:focus {\n    color: ", ";\n    text-decoration-color: currentcolor;\n    text-decoration-line: underline;\n  }\n\n  &[data-focus-visible-added]:focus {\n    outline: 1px solid ", ";\n    outline-offset: 2px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ButtonLink = _styledComponents.default.button(_templateObject(), _Constant.Color.BLACK_SOUL, _Constant.Color.FOCUS_B, _Constant.Color.FOCUS_B);

var BackArrow = _styledComponents.default.img(_templateObject2());

var P = _styledComponents.default.h5(_templateObject3());

var BreadCrumb = function BreadCrumb(_ref) {
  var children = _ref.children,
      _onClick = _ref.onClick,
      chevron = _ref.chevron,
      arrow = _ref.arrow,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "onClick", "chevron", "arrow"]);
  return /*#__PURE__*/_react.default.createElement(ButtonLink, (0, _extends2.default)({
    onClick: function onClick() {
      return _onClick();
    }
  }, rest), arrow ? /*#__PURE__*/_react.default.createElement(BackArrow, {
    alt: "back arrow",
    src: _backArrow.default
  }) : /*#__PURE__*/_react.default.createElement(BackArrow, {
    alt: "back arrow",
    src: _leftChevron.default
  }), /*#__PURE__*/_react.default.createElement(P, null, children));
};

BreadCrumb.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  children: _propTypes.default.string.isRequired,
  chevron: _propTypes.default.bool,
  arrow: _propTypes.default.bool
};
BreadCrumb.defaultProps = {
  chevron: false,
  arrow: false
};
var _default = BreadCrumb;
exports.default = _default;